module.exports = __webpack_public_path__ + "static/media/appointment-accepting.dd23b964.svg";